import React, { useEffect, useState, useCallback } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, Typography, DialogContent, DialogTitle, DialogActions, styled, Drawer, IconButton, } from "@mui/material";
import Welcome from "../components/patient/Welcome";
import theme, { typography } from "src/config/theme";
import { palette, shadows } from "src/config/theme";
import { ReactComponent as Edit2 } from '../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../assets/images/close-circle.svg';
import { ReactComponent as Add } from '../../../assets/images/add-square.svg';
import { ReactComponent as View } from '../../../assets/images/eye.svg';
import { useNavigate } from 'react-router-dom';
import NoDataFound from "../components/NoDataFound/NoDataFound";
import { useDispatch, useSelector } from 'react-redux';
import { getTaskRequest, postTaskCommentByTaskIdReuest } from '../../../modules/app/store/appActions';
import storage from "src/utils/storageUtils";
import RightSidebar from "../../../components/App/RIghtSidebar/RightSidebar";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import ButtonComponent from "src/components/shared/Button";
import AddStaff from "../components/LefSidebarForms/AddStaff/AddStaff";
import TaskCard from "../components/CustomCard/TaskCard";
import InputComponent from "src/components/shared/Form/Input";
import useResponsive from "src/components/hooks/useResponsive";
import AddTask from "../components/LefSidebarForms/AddTask/AddTask";
import dayjs from "dayjs";
import { isSanginiRestrictedUser } from "src/utils/sanginiUtils";
import NotAccessible from "src/components/App/NotAccessible";
export const AvatarIcon = styled(Avatar)({
  width: '64px',
  height: '64px',
  padding: '10px',
  borderRadius: '40px',
  background: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18)), #FFFFFF',
  marginBottom: '5px'
})

const columns = [
  { id: "name", label: "Task Name", sx: { "& .css-s1474d": { justifyContent: 'flex-Start !important' }, textAlign: 'left !important', width: '200px' }, },
  // { id: "description", label: "Description", sx: { "& .css-axw7ok": { justifyContent: 'flex-start !important' }, textAlign: 'left !important', width: '300px' } },
  { id: "assignedTo", label: "Assigned To", sx: { "& .css-axw7ok": { justifyContent: 'flex-start !important' }, textAlign: 'left !important', width: '200px' } },
  { id: "dueDate", label: "Due Date", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } } },
  { id: "priority", label: "Priority", sx: { "& .css-axw7ok": { justifyContent: 'center !important' } } },
  { id: "taskStatus", label: 'Task Status', sx: { "& .css-axw7ok": { justifyContent: 'center !important' } } }
];

const TaskContainer = () => {
  const { isMobile, isDesktop, isTablet } = useResponsive();

  const [isCardView, setIsCardView] = useState(false);
  const [open, setOpen] = useState(false);
  const [task, setTask] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedTask, setSelectedTask] = useState(null);
  const [comment, setComment] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fetchTask = useCallback(
    (page = 0, perPage = 10) => {
      const token = storage.get('TOKEN');
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const params = {
            page: page + 1,
            limit: perPage,
          };
          const response = await new Promise((resolve, reject) =>
            dispatch(getTaskRequest({ token, params }, resolve, reject)),
          );
          if (response?.data && response?.meta) {
            setTask(response.data);
            setTotalCount(response.meta.total);
          }
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    },
    [dispatch],
  );
  useEffect(() => {
    fetchTask(page, perPage);
  }, [fetchTask, page, perPage]);

  const handleSearch = useCallback((value) => {
    const token = storage.get('TOKEN');
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const params = value ? { search: value } : null;
        console.log("Params received in getPatient:", params);
        const response = await new Promise((resolve, reject) =>
          dispatch(getTaskRequest({ token, params }, resolve, reject))
        );
        console.log("search response", response);
        if (response) {
          setTask(response.data);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  const getChipStyles = (type, value, index = 0) => {
    const colors = {
      assigned: [
        { bg: 'linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))', text: theme.palette.action.purpleDark },
        { bg: 'linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))', text: theme.palette.action.purpleLight },
        { bg: 'linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))', text: theme.palette.action.green },
      ],
      priority: {
        high: { bg: 'linear-gradient(0deg, rgba(255, 0, 0, 0.12), rgba(255, 0, 0, 0.12))', text: theme.palette.error.main },
        medium: { bg: 'linear-gradient(0deg, rgba(255, 165, 0, 0.14), rgba(255, 165, 0, 0.14))', text: theme.palette.warning.main },
        low: { bg: 'linear-gradient(0deg, rgba(169, 169, 169, 0.18), rgba(169, 169, 169, 0.18))', text: theme.palette.grey[700] },
        default: { bg: 'linear-gradient(0deg, rgba(200, 200, 200, 0.18), #fff)', text: theme.palette.text.primary }
      },
      taskStatus: {
        pending: { bg: 'linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))', text: theme.palette.action.purpleDark },
        in_progress: { bg: 'linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))', text: theme.palette.action.purpleLight },
        completed: { bg: 'linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))', text: theme.palette.action.green },
        overdue: { bg: 'linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))', text: theme.palette.action.red },
        default: { bg: 'linear-gradient(0deg, rgba(200, 200, 200, 0.18), #fff)', text: theme.palette.gery.black }
      }
    };

    if (type === 'assigned') return colors.assigned[index % colors.assigned.length];

    const colorGroup = colors[type];
    return colorGroup[value] || colorGroup.default;
  };

  const data = task.map((taskData) => ({
    taskId: taskData.id,
    avatarInitial: taskData?.name?.charAt(0).toUpperCase() || 'N',
    name: taskData?.name,
    description: taskData?.description,
    assignedTo: (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: isCardView ? 'center' : 'flex-start' }}>
        {(Array.isArray(taskData?.assigned) ? taskData.assigned : []).map((email, index) => {
          const { bg, text } = getChipStyles("assigned", email, index);
          return (
            <Chip
              key={email}
              avatar={<Avatar sx={{
                width: 24, height: 24, background: text,
                color: theme.palette.gery.white,
                ...theme.typography.small,
              }}>{email[0]?.toUpperCase()}</Avatar>}
              label={email}
              sx={{
                background: bg,
                color: text,
                ...theme.typography.small,
                borderRadius: '12px',
                '& .MuiChip-avatar': {
                  color: '#fff',
                },
              }}
            />
          );
        })}
      </Box>
    ),

    dueDate: dayjs(taskData?.dueDate).format("DD-MM-YYYY"),
    priority: (
      <Chip
        label={taskData?.priority}
        sx={() => {
          const { bg, text } = getChipStyles('priority', taskData.priority);
          return {
            background: bg,
            color: text,
            ...theme.typography.small,
            borderRadius: '100px',
            padding: '10px 18px 8px 18px',
          };
        }}
      />
    ),
    taskStatus: (
      <Chip
        label={taskData?.taskStatus}
        sx={() => {
          const { bg, text } = getChipStyles('taskStatus', taskData.taskStatus);
          return {
            background: bg,
            color: text,
            ...theme.typography.small,
            borderRadius: '100px',
            padding: '10px 18px 8px 18px',
          };
        }}
      />
    ),
  }));
  const actions = [
    // { label: "Edit", icon: <Edit2 />, onClick: (row) => alert(`Editing`) },
    // {
    //   label: "Cancel", icon: <Close width={isMobile || isTablet ? 18 : 24}
    //     height={isMobile || isTablet ? 18 : 24} />, onClick: (row) => alert(`Editing `)
    // },
    {
      label: "View Details", icon: <View />, onClick: (row) => {
        const taskItem = task.find(t => t.id === row.taskId);
        setSelectedTask(taskItem);
        setSidebarOpen(true);
      }
    }
  ];
  const handlePostComment = async () => {
    const taskId = selectedTask?.id
    if (!selectedTask?.id || !comment.trim()) return;
    const data = {
      message: comment
    };
    const response = await new Promise((resolve, reject) =>
      dispatch(postTaskCommentByTaskIdReuest(taskId, data, resolve, reject))
    );
    if (response?.data) {
      const newComment = {
        id: response.data.id, // use proper ID from response
        commenterName: response.data.commenterName, // depends on API shape
        message: response.data.message,
      };

      setSelectedTask(prev => ({
        ...prev,
        comments: [...(prev.comments || []), newComment],
      }));
    }

    setComment('');
  }


  return (
    <>
      <Welcome category="tasks" setIsCardView={setIsCardView} isCardView={isCardView} updateTask={fetchTask} handleSearch={handleSearch} />
      <Box sx={{ mb: 16 }} />

      <Box sx={{
        height: 'calc(100vh - 240px)',
        margin: 2,
        boxShadow: isMobile || isTablet || isCardView || isCardView ? 'none' : theme.shadows[1],
        borderRadius: '10px',
        border: isMobile || isTablet || isCardView || isCardView ? 'none' : `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
        backgroundColor: isMobile || isTablet || isCardView ? 'none' : theme.palette.gery.white,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: (isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'space-between',
        alignItems: (isMobile || isTablet || isCardView) && Array.isArray(data) && data.length === 0 ? 'center' : 'none',
        position: 'relative',
        maxHeight: 'calc(100vh - 240px)'
      }}>
        {(isMobile || isTablet || isCardView) ? (
          data.length === 0 ? (
            <NoDataFound
              title="No Task Found!"
              buttonText="Add Task"
              buttonIcon={Add}
              onClick={handleOpen}
            />
          ) : (
            <TaskCard
              data={data}
              page={page}
              perPage={perPage}
              setPage={setPage}
              totalCount={totalCount}
            />
          )
        ) : (
          <CustomTable
            columns={columns}
            data={data}
            actions={actions}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            loading={isLoading}
            noDataComponent={
              isLoading ? <></> : (
                <NoDataFound
                  title="No Task Found!"
                  buttonText="Add Task"
                  buttonIcon={Add}
                  onClick={handleOpen}
                />
              )
            }
          />
        )}





      </Box>

      <DialogBox open={open} onClose={handleClose}>
        <AddTask onClose={handleClose} updateTask={fetchTask} />
      </DialogBox>

      <RightSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Drawer
        anchor="right"
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        PaperProps={{
          sx: {
            width: 400,
          },
        }}
        key={selectedTask?.id}
      >
        <Box sx={{ height: '84px', backgroundColor: theme.palette.primary.light3, border: `1px solid ${theme.palette.primary.light1}`, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ width: '332px', height: '24px', display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h3">Task Details</Typography>
            <Close width={isMobile || isTablet ? '20px' : '24px'} height={isMobile || isTablet ? '20px' : '24px'} onClick={() => setSidebarOpen(false)} sx={{ color: theme.palette.gery.black }} style={{ cursor: 'pointer' }} />
          </Box>
        </Box>
        {selectedTask && (
          <>
            <Box sx={{ display: 'flex', justifyContent: 'flexStart', flexDirection: 'column', margin: '32px 24px', width: 'auto' }}>

              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="h5" sx={{ color: theme.palette.gery.black }}>Name</Typography>
                  <Typography variant="smallRegular" mb={2} >{selectedTask.name}</Typography>
                </Box>
                <Chip
                  label={selectedTask.taskStatus}
                  sx={() => {
                    const { bg, text } = getChipStyles('taskStatus', selectedTask.taskStatus);
                    return {
                      background: bg,
                      color: text,
                      ...theme.typography.small,
                      borderRadius: '100px',
                      padding: '10px 18px 8px 18px',
                      width: '150px'
                    };
                  }}
                />
              </Box>
              <Typography variant="h5" sx={{ color: theme.palette.gery.black }}>Description</Typography>
              <Typography variant="smallRegular" mb={2}>{selectedTask.description}</Typography>

              <Typography variant="h5" sx={{ color: theme.palette.gery.black }}>Assigned To</Typography>
              <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
                {selectedTask.assigned?.map((email, index) => {
                  const { bg, text } = getChipStyles("assigned", email, index);
                  return (
                    <Chip
                      key={email}
                      label={email}
                      avatar={
                        <Avatar sx={{
                          width: 24,
                          height: 24,
                          background: text,
                          color: theme.palette.gery.white,
                          ...theme.typography.small,
                        }}>
                          {email[0]?.toUpperCase()}
                        </Avatar>
                      }
                      sx={{
                        background: bg,
                        color: text,
                        ...theme.typography.small,
                        borderRadius: '12px',
                        '& .MuiChip-avatar': {
                          color: '#fff',
                        },
                      }}
                    />
                  );
                })}
              </Box>
              <Typography variant="h5" sx={{ color: theme.palette.gery.black }}>Due Date</Typography>
              <Typography variant="smallRegular" mb={2}>{dayjs(selectedTask.dueDate).format("DD MMM YYYY")}</Typography>
              <Typography variant="h5" sx={{ color: theme.palette.gery.black }}>Priority</Typography>
              <Chip
                label={selectedTask.priority}

                sx={() => {
                  const { bg, text } = getChipStyles('priority', selectedTask.priority);
                  return {
                    background: bg,
                    color: text,
                    ...theme.typography.small,
                    borderRadius: '100px',
                    padding: '10px 18px 8px 18px',
                    width: '150px',
                    marginBottom: '50px'
                  };
                }} />

            </Box>
          </>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '140px', margin: '8px 24px', borderRadius: '12px', }}>
          <Box sx={{ margin: '10px 0' }}>
            <Typography variant="h5" sx={{ borderBottom: `1px solid ${alpha(theme.palette.gery.black, 0.2)}` }}>Comments</Typography>
          </Box>
          <Box sx={{ height: '100px', overflowY: 'scroll', margin: '5px 0' }}>
            {selectedTask?.comments?.map((comment) => (
              <Box key={comment.id} sx={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                <Avatar sx={{ width: 28, height: 28, ...typography.h5, background: theme.palette.primary.main }}>
                  {comment.commenterName?.charAt(0).toUpperCase()}
                </Avatar>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h5" sx={{ color: theme.palette.primary.main }}>
                    {comment.commenterName}
                  </Typography>

                  <Typography variant="smallRegular">{comment.message}</Typography>
                </Box>
              </Box>
            ))}
          </Box>

        </Box>
        <Box sx={{ border: `1px solid ${alpha(theme.palette.gery.black, 0.2)}`, marginTop: '8px' }}></Box>
        <Box sx={{ border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`, borderRadius: '12px', padding: '5px', margin: '8px 24px' }}>
          <InputComponent
            variant="outlined"
            name="comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Enter Comments"
            fullWidth
            multiline
            rows={3}
            sx={{
              backgroundColor: palette.gery.white,
              boxShadow: shadows[1],
              '& .MuiOutlinedInput-root': {
                padding: '10px 12px',
                borderRadius: '12px',
                // height: '80px',
                alignItems: 'flex-start',
                border: 'none',
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonComponent
              type="submit"
              onClick={handlePostComment}
              sx={{
                width: '150px',
                height: '45px',
                borderRadius: '12px',
                padding: '10px 18px',
                backgroundColor: palette.primary.main,
                boxShadow: shadows[1],
                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,

                color: palette.gery.white,
                '&:hover': { color: palette.primary.main },
              }}
            >Comment</ButtonComponent>
          </Box>
        </Box>
      </Drawer >

    </>
  )
};

export default TaskContainer;